import React from 'react';

const BracesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 15a4.5 4.5 0 0 0 9 0" />
    <path d="M6 9a4.5 4.5 0 0 1 9 0" />
    <path d="M3 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2" />
    <path d="M21 9a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2" />
    <path d="M8.5 9h-1" />
    <path d="M16.5 9h-1" />
    <path d="M12 9v0" />
    <path d="M8.5 15h-1" />
    <path d="M16.5 15h-1" />
    <path d="M12 15v0" />
    <path d="M3 12h18" />
  </svg>
);

export default BracesIcon;
